import React,
{
    useEffect,
    useRef,
    useState
}
from 'react';
import
{
    navigate
}
from './Router';
import masterVolume from './masterVolume';

export default function Discord()
{
    const [showInfo, setShowInfo] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const tagAppearAudioRef = useRef(null);

    useEffect(() =>
    {
        const infoTimer = setTimeout(() => setShowInfo(true), 850);
        const buttonTimer = setTimeout(() => setShowButton(true), 1080);
        return () =>
        {
            clearTimeout(infoTimer);
            clearTimeout(buttonTimer);
        };
    }, []);

    useEffect(() =>
    {
        let audio = null;
        try
        {
            audio = new Audio('/Audio/Discord-TagAppear.ogg');
            audio.preload = 'auto';
            audio._baseVolume = 0.75;
            try
            {
                masterVolume.applyToElement(audio);
            }
            catch (e)
            {}
            tagAppearAudioRef.current = audio;
            try
            {
                audio.currentTime = 0;
            }
            catch (e)
            {}
            try
            {
                audio.play().catch(() =>
                {});
            }
            catch (e)
            {}
        }
        catch (e)
        {}

        return () =>
        {
            const current = tagAppearAudioRef.current || audio;
            if (!current) return;
            try
            {
                current.pause();
            }
            catch (e)
            {}
            try
            {
                current.currentTime = 0;
            }
            catch (e)
            {}
            try
            {
                if (typeof current._masterVolumeUnsub === 'function') current._masterVolumeUnsub();
            }
            catch (e)
            {}
            tagAppearAudioRef.current = null;
        };
    }, []);

    return ( <div style = {
            {
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'auto'
            }
        } >
        <div style = {
            {
                textAlign: 'center',
                color: '#fff',
                padding: 24,
                maxWidth: 720
            }
        } >
        <img src = {
            '/Static-Intro.png'
        }
        alt = "static intro"
        draggable = {
            false
        }
        style = {
            {
                width: 'min(82vw, 520px)',
                height: 'auto',
                display: 'block',
                margin: '0 auto'
            }
        }
        />

        <div style = {
            {
                marginTop: 18,
                minHeight: 128,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }
        } >
        <div style = {
            {
                fontSize: '1.1rem',
                fontWeight: 600,
                opacity: showInfo ? 0.95 : 0,
                lineHeight: 1.35,
                transform: showInfo ? 'translateY(0)' : 'translateY(10px)',
                transition: 'opacity 320ms ease, transform 320ms ease',
                maxWidth: 680,
            }
        } >
        It 's usually my alias for almost every account. If theres an account under this handle, its probably me! </div> <button type = "button"
        onClick = {
            () => navigate('/main')
        }
        style = {
            {
                marginTop: 16,
                padding: '10px 18px',
                borderRadius: 8,
                background: '#ffffff10',
                border: '1px solid #ffffff40',
                color: '#fff',
                cursor: showButton ? 'pointer' : 'default',
                opacity: showButton ? 1 : 0,
                transform: showButton ? 'translateY(0)' : 'translateY(10px)',
                transition: 'opacity 320ms ease, transform 320ms ease',
                pointerEvents: showButton ? 'auto' : 'none',
            }
        } >
        Return to / main </button> </div> </div> </div>
    );
}
